module.exports = __webpack_public_path__ + "img/about.1df16bce.png";